import {Scroll} from './Scroll' 

(function(){
    const $spyItems = document.querySelectorAll('.scroll-spy')
    $spyItems.forEach(($s) => new Scroll.Spy($s))
    const $scrollToItems = document.querySelectorAll('.scroll-to-target')
    $scrollToItems.forEach(($s) => new Scroll.ScrollTo($s))
})()